import {PersonType, personTypes} from "@ots-frontend/ots-data";
import {BaseDbCodeSelect, DbCodeSelectProps} from "../base-db-code-select";

type Props = DbCodeSelectProps<PersonType>;

export const PersonTypeSelect = (props: Props) => {
  const {options = personTypes, ...rest} = props;
  return <BaseDbCodeSelect options={options} {...rest} />;
};
